import { BookOpen, Link2, FileText, GraduationCap, Feather, Bookmark } from 'lucide-react';

const STYLES = [
  { match: /مساق/, icon: Link2, chip: 'bg-[#3A5F0B]/10 text-[#3A5F0B] border-[#3A5F0B]/20', cover: ['#4F6F2A', '#2F4A12'] },
  { match: /مقال/, icon: FileText, chip: 'bg-sky-50 text-sky-800 border-sky-200', cover: ['#4A7A8C', '#2B4D5C'] },
  { match: /دراس|بحث/, icon: GraduationCap, chip: 'bg-teal-50 text-teal-800 border-teal-200', cover: ['#3F7F77', '#22524C'] },
  { match: /رواي|قص/, icon: Feather, chip: 'bg-rose-50 text-rose-800 border-rose-200', cover: ['#A0645A', '#6B3A33'] },
  { match: /كتاب/, icon: BookOpen, chip: 'bg-[#C19A6B]/12 text-[#5D4037] border-[#C19A6B]/30', cover: ['#C19A6B', '#5D4037'] },
];
const DEFAULT_STYLE = { icon: Bookmark, chip: 'bg-stone-100 text-stone-700 border-stone-200', cover: ['#8D7B68', '#4E4237'] };

export const categoryStyle = (name = '') => STYLES.find((s) => s.match.test(name)) || DEFAULT_STYLE;

export const resolveImage = (url) => (url && url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const formatDate = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString('ar-OM', { day: 'numeric', month: 'long', year: 'numeric' }); } catch { return ''; }
};

export const initialOf = (name = '') => (name.trim().replace(/^(ال)/, '')[0] || '؟');

export const FILTER_KEYS = ['q', 'category', 'sort', 'mine', 'liked', 'with_image', 'reader', 'author', 'min_pages', 'max_pages', 'date_from', 'date_to'];

export const FILTER_LABELS = {
  mine: () => 'ملخصاتي', liked: () => 'ما أعجبني', with_image: () => 'مع صورة',
  reader: (v) => `القارئ: ${v}`, author: (v) => `المؤلف: ${v}`,
  min_pages: (v) => `من ${v} صفحة`, max_pages: (v) => `حتى ${v} صفحة`,
  date_from: (v) => `من ${v}`, date_to: (v) => `إلى ${v}`, q: (v) => `بحث: ${v}`, category: (v) => v,
};
